// src/Component/hooks/usePostJenis_beban.jsx
import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * @returns { Object } - Mengembalikan fungsi postJenisBeban, serta status loading dan error.
 */
const usePostJenisBeban = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk mengirim data jenis beban ke backend.
   * @param { string } nama_beban
   * @returns { Promise<Object> } - Mengembalikan data respons dari backend atau error.
   */
  const postJenisBeban = async (nama_beban) => {
    setLoading(true);
    setError(null);

    try {
      const data = {
        nama_beban,
      };

      const response = await api.post(endpoints.jenis_beban.create, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (err) {
      console.error('Error uploading jenis beban:', err);
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        'Terjadi kesalahan saat mengupload data jenis beban.'
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { postJenisBeban, loading, error };
};

export default usePostJenisBeban;
